var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFlag = function SvgIconFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14.875a1 1 0 0 0 .894-1.447l-1.776-3.553 1.776-3.553A1 1 0 0 0 20 4.875H9v-1a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0v-7h11Z",
    fill: "#fff",
    fillOpacity: 0.75
  })));
};
export default SvgIconFlag;